const STORAGE_PREFIX = 'adminActivityRosterExportFields_v1_'
const COLLECT_PREFIX = 'collect:'

/** 与后端 ActivityRosterExportService.SYSTEM_FIELDS 对齐 */
export const ROSTER_EXPORT_SYSTEM_FIELDS = [
  { key: 'identityLabel', label: '身份', group: '基础信息', defaultSelected: true },
  { key: 'attendeeName', label: '姓名', group: '基础信息', defaultSelected: true },
  { key: 'attendeePhone', label: '手机号', group: '基础信息', defaultSelected: true },
  { key: 'attendeeCompany', label: '单位名称', group: '基础信息', defaultSelected: true },
  { key: 'attendeeDuty', label: '单位职务', group: '基础信息', defaultSelected: true },
  { key: 'activityStatusLabel', label: '活动状态', group: '基础信息', defaultSelected: true },
  { key: 'orderStatusText', label: '订单状态', group: '基础信息', defaultSelected: true },
  { key: 'submittedAt', label: '报名时间', group: '基础信息', defaultSelected: true },
  { key: 'cancelledAt', label: '取消报名时间', group: '基础信息', defaultSelected: true },
  { key: 'submitterInfo', label: '报名者信息', group: '基础信息', defaultSelected: true },
  { key: 'memberTags', label: '标签', group: '基础信息', defaultSelected: false },
  { key: 'signupFormSubmissionId', label: '报名提交ID', group: '基础信息', defaultSelected: true },
  { key: 'signupChannel', label: '报名渠道', group: '扩展信息', defaultSelected: false },
  { key: 'seatingLabel', label: '座位', group: '扩展信息', defaultSelected: false },
  { key: 'checkinAt', label: '签到时间', group: '扩展信息', defaultSelected: false },
  { key: 'memberLevel', label: '会员级别', group: '扩展信息', defaultSelected: false },
  { key: 'serviceConsultant', label: '服务专员', group: '扩展信息', defaultSelected: false },
]

export function rosterExportStorageKey(activityId) {
  return `${STORAGE_PREFIX}${activityId || 0}`
}

export function readSavedRosterExportFieldKeys(activityId) {
  try {
    const raw = localStorage.getItem(rosterExportStorageKey(activityId))
    if (!raw) return []
    const arr = JSON.parse(raw)
    if (!Array.isArray(arr)) return []
    return arr.map((x) => String(x || '').trim()).filter(Boolean)
  } catch {
    return []
  }
}

export function persistRosterExportFieldKeys(activityId, keys) {
  const list = Array.isArray(keys) ? keys.map((x) => String(x || '').trim()).filter(Boolean) : []
  try {
    localStorage.setItem(rosterExportStorageKey(activityId), JSON.stringify(list))
  } catch {
    /* ignore */
  }
}

export function resolveRosterExportSelectedKeys(activityId, fieldOptions) {
  const saved = readSavedRosterExportFieldKeys(activityId)
  if (saved.length) {
    const valid = new Set((fieldOptions || []).map((o) => o.key))
    return saved.filter((k) => valid.has(k))
  }
  return (fieldOptions || []).filter((o) => o.defaultSelected).map((o) => o.key)
}

export function groupRosterExportFields(fieldOptions) {
  const groups = []
  const map = new Map()
  ;(fieldOptions || []).forEach((o) => {
    const g = o.group || '其他'
    if (!map.has(g)) {
      map.set(g, [])
      groups.push({ name: g, items: map.get(g) })
    }
    map.get(g).push(o)
  })
  return groups
}

function parseCollectFieldsFromActivity(activityDetail) {
  const d = activityDetail && typeof activityDetail === 'object' ? activityDetail : {}
  let raw =
    d.signupActivityCollectJson ??
    d.signup_activity_collect_json ??
    d.activityInfoCollect ??
    d.activity_info_collect ??
    null
  if (raw == null || raw === '') return []
  if (typeof raw === 'string') {
    try {
      raw = JSON.parse(raw)
    } catch {
      return []
    }
  }
  if (!Array.isArray(raw)) return []
  return raw
    .map((x, i) => {
      if (!x || typeof x !== 'object') return null
      const fieldKey = String(x.fieldKey || x.field_key || `field_${i}`).trim()
      if (!fieldKey) return null
      const label = String(x.label || x.fieldLabel || fieldKey).trim()
      return {
        key: `${COLLECT_PREFIX}${fieldKey}`,
        label: label || fieldKey,
        group: '本场报名表字段',
        defaultSelected: false,
      }
    })
    .filter(Boolean)
}

/** 前端本地构建（不依赖新接口）；activityDetail 来自 getAdminCmsActivity */
export function buildRosterExportFieldOptions(activityDetail) {
  const collect = parseCollectFieldsFromActivity(activityDetail)
  return [...ROSTER_EXPORT_SYSTEM_FIELDS, ...collect]
}
